
    import "src/shared/components/Loading/loader.module.scss?farm_css_modules";
    
    export default {"delay1": `delay1-3302951d`,"delay2": `delay2-3302951d`,"delay3": `delay3-3302951d`,"indicator": `indicator-3302951d`,"loader": `loader-3302951d`,"loaderCircle": `loaderCircle-3302951d`,"loading": `loading-3302951d`,"modalContent": `modalContent-3302951d`}
    